import * as Sentry from '@sentry/browser';
import { DEFAULT_CHAT_SETTINGS } from '@wix/inbox-common';
import { fonts } from '../reducers/fonts';
import {
  updateEditorSettingsDesign,
  updateEditorSettingsLayout,
  updateEditorSettingsTexts,
  updateSiteColors,
  updateStyleParamsColors,
  updateStyleParamsFonts,
} from '../actions';
import colors from '../reducers/colors';
import {
  editorSettingsDesign,
  editorSettingsLayout,
  editorSettingsTexts,
} from '../reducers/editorSettings';

export interface SiteData {
  styleParams?: {
    colors?: any;
    booleans?: any;
    fonts?: any;
  };
  siteColors?: any;
  publicData?: {
    texts?: any;
    design?: any;
    layout?: any;
  };
}

export const extractSiteData = (siteData: SiteData) => {
  try {
    const { siteColors, publicData, styleParams } =
      siteData || ({} as SiteData);

    return {
      fonts: fonts(
        undefined,
        updateStyleParamsFonts(styleParams && styleParams.fonts),
      ),
      colors: colors(
        colors(undefined, updateSiteColors(siteColors)),
        updateStyleParamsColors(styleParams && styleParams.colors),
      ),
      editorSettingsDesign: editorSettingsDesign(
        editorSettingsDesign(
          undefined,
          updateEditorSettingsDesign(DEFAULT_CHAT_SETTINGS.design),
        ),
        updateEditorSettingsDesign(publicData && publicData.design),
      ),
      editorSettingsLayout: editorSettingsLayout(
        editorSettingsLayout(
          undefined,
          updateEditorSettingsLayout({
            ...DEFAULT_CHAT_SETTINGS.layout,
            collapsedAsRounded:
              (styleParams &&
                styleParams.booleans &&
                styleParams.booleans.collapsedAsRounded) ||
              DEFAULT_CHAT_SETTINGS.layout.collapsedAsRounded,
          }),
        ),
        updateEditorSettingsLayout(publicData && publicData.layout),
      ),
      editorSettingsTexts: editorSettingsTexts(
        editorSettingsTexts(
          undefined,
          updateEditorSettingsTexts(DEFAULT_CHAT_SETTINGS.texts),
        ),
        updateEditorSettingsTexts(publicData && publicData.texts),
      ),
    };
  } catch (e) {
    Sentry.captureException(e);
    return {};
  }
};
